import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { SubHelper } from '../../_ui-core_/base/package/patterns/package/store';
import App from '../../app';
import type { Layout } from '../../app/package/base/types';
import style from './cat-filter-page.css?inline';

const CName = 'cat-filter-page';

@customElement(CName)
export class CatFilterPage extends LitElement {
  static readonly styles = unsafeCSS(style);

  @state() private _layout: Layout | undefined;
  @state() private _showRenderedContent = false;

  private readonly _subHelper = new SubHelper();

  connectedCallback() {
    super.connectedCallback();
    this._subHelper.addSub(App.instance.layoutStore, (_) => this._updateLayout(_), true);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this._subHelper.unsubscribeAll();
  }

  firstUpdated(): void {
    this._subHelper.addSub(
      window.$app.renderService.renderStore,
      (renderStatus) => {
        this._showRenderedContent = renderStatus === 'visible';
      },
      true,
    );
    window.$app.renderService.removePageTemplateTask();
  }

  render() {
    const classes = classMap({
      'cat-filter-page': true,
      [this._layout!]: true,
      hidden: !this._showRenderedContent,
    });
    return html`
      <main class=${classes}>
        <slot @restore-scroll-position=${(ev: Event) => {
          ev.stopPropagation();
          App.instance.router.restoreScrollPosition();
        }}></slot>
      </main>
    `;
  }

  private _updateLayout(layout: Layout) {
    this._layout = layout;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: CatFilterPage;
  }
}
